/**
 * @generated SignedSource<<ce54b7ebdc7ef0d26c3d185d54393378>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ContainerTeaserItemExternalQuery$variables = {
  forceFresh?: boolean | null;
  thumbnailWidth?: number | null;
  url: string;
};
export type ContainerTeaserItemExternalQuery$data = {
  readonly meta: {
    readonly date: string | null;
    readonly description: string | null;
    readonly source: string;
    readonly thumbnail: string | null;
    readonly title: string;
  } | null;
};
export type ContainerTeaserItemExternalQuery = {
  response: ContainerTeaserItemExternalQuery$data;
  variables: ContainerTeaserItemExternalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forceFresh"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thumbnailWidth"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "url"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "forceFresh",
        "variableName": "forceFresh"
      },
      {
        "kind": "Variable",
        "name": "thumbnailWidth",
        "variableName": "thumbnailWidth"
      },
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "Meta",
    "kind": "LinkedField",
    "name": "meta",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "source",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "thumbnail",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerTeaserItemExternalQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContainerTeaserItemExternalQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9eaafb38e2509cd4926bbb895d91da01",
    "id": null,
    "metadata": {},
    "name": "ContainerTeaserItemExternalQuery",
    "operationKind": "query",
    "text": "query ContainerTeaserItemExternalQuery(\n  $url: String!\n  $thumbnailWidth: Int\n  $forceFresh: Boolean\n) {\n  meta(url: $url, thumbnailWidth: $thumbnailWidth, forceFresh: $forceFresh) {\n    title\n    date\n    description\n    source\n    thumbnail\n  }\n}\n"
  }
};
})();

(node as any).hash = "410bfecde8906170be54d9f6f685974c";

export default node;
